<template>
<div :class="$style.root">

  <div
    v-for="(item, index) in value"
    :key="index">
    <stairstep-price-item
      ref="stairstepPriceItems"
      :readonly="!(!readonly && isLastOne(index))"
      :index="index"
      :isLast="index === value.length - 1"
      v-model="value[index]">
    </stairstep-price-item>
    <div v-show="!readonly && value && isLastOne(index)" style="display:inline-block;vertical-align:top;margin-left:10px;">
      <el-button
        icon="el-icon-plus"
        @click="add(value[index],
        $refs['stairstepPriceItems'][index])"
        type="primary"
        :disabled="!canAdd">
      </el-button>
      <el-button
        icon="el-icon-delete"
        @click="remove"
        type="danger"
        :disabled="!canRemove">
      </el-button>
    </div>
  </div>

</div>
</template>

<script>
import StairstepPriceItem from './stairstep-price-item'
import * as constants from '../../constants'

export default {

  props: {
    value: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
    }
  },
  computed: {
    canAdd() {
      return this.value && this.value.length < constants.STAIR_MAX_PER_YEAR
    },
    canRemove() {
      return this.value && this.value.length > 1
    }
  },
  watch: {
    value: {
      handler(val) {
        if(!this.readonly && val.length === 0) {
          this.add()
        }
      }
    }
  },
  methods: {
    validate() {
      let validates = this.$refs['stairstepPriceItems'] || []
      return Promise.all(validates.map(item => item.validate())).then(results => {
        return results.every(result => result)
      })
    },
    $_addItem(current = {}) {
      let value = []
      Array.prototype.push.apply(value, this.value)
      value.push({
        name: `第 ${value.length + 1} 阶梯`,
        lowlimit: current.uplimit || 0,
        uplimit: constants.STAIR_MAX_LIMIT,
        stairtype: constants.STAIR_TYPE_RATIO,
        speprice: null,
        speratio: 0
      })
      this.$emit('input', value)
    },
    add(current, item) {
      // 当前规则校验通过才能添加新的规则
      if(current) {
        item.validate().then((valid) => {
          if(valid) {
            this.$_addItem(current)
          } else {
            return false
          }
        })
      } else {
        this.$_addItem()
      }
    },
    remove() {
      let value = this.value.slice(0, this.value.length - 1)
      value[value.length - 1].uplimit = constants.STAIR_MAX_LIMIT
      this.$emit('input', value)
    },
    isLastOne(index) {
      return index === this.value.length - 1
    }
  },

  components: {
    StairstepPriceItem
  }
}
</script>

<style lang="less" module>
.root{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/pricing/components/stairstep-price.vue